import React, { FC } from 'react'
import { Box, Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { ProductSize } from '@/network/graphql.g'
import { ID } from 'graphql-ws'
import ProductsSlider, {
  ProductSlide
} from '@/components/organisms/productsSlider'
import { SizeMe } from 'react-sizeme'
import { ProductCardMode } from '@/components/organisms/productCard/productCardMode'
import RemoveProductButtons from '@/components/molecules/iconButtons/removeProductButtons'
import { ProductSizeBoxRedesign } from '@/components/molecules/productSizeBox'

type ProductCardHoverMenuRedesignProps = {
  sizes?: ProductSize[]
  mode: ProductCardMode
  id: ID
  mainCategoryId: string
} & Rest

export const ProductCardHoverMenuRedesign: FC<ProductCardHoverMenuRedesignProps> =
  ({ sizes, mode, id, mainCategoryId, ...rest }) => {
    const getNumberOfSlides = (width: number) => {
      if (!width) {
        return 1
      }
      const imageWidth = 40
      const num = Math.floor(width / imageWidth) + 0.5
      if (num * imageWidth > width) {
        return num - 1
      } else {
        return num
      }
    }

    return (
      <Wrapper
        data-testid={
          mode === ProductCardMode.recommended ? 'productImagesContainer' : null
        }
        {...rest}
      >
        <Flex height="100%" flexDirection="column" justifyContent="flex-end">
          {(sizes?.length ?? 0) > 0 && (
            <>
              <Box height={50}>
                <SizeMe>
                  {({ size }) => (
                    <ProductsSlider
                      slidesToShow={getNumberOfSlides(size?.width)}
                      showArrows={false}
                    >
                      {sizes.map(({ value }, offset) => (
                        <ProductSlide key={offset}>
                          <StyledProductSizeBoxRedesign
                            mx="3px"
                            index={offset}
                            key={value}
                            title={value.toUpperCase()}
                            value={value.toUpperCase()}
                            data-testid="productSizeBox"
                          />
                        </ProductSlide>
                      ))}
                    </ProductsSlider>
                  )}
                </SizeMe>
              </Box>
            </>
          )}
          <RemoveProductButtons
            productId={id}
            mainCategoryId={mainCategoryId}
          />
        </Flex>
      </Wrapper>
    )
  }

const Wrapper = styled(Box)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 0 0 4px 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

const StyledProductSizeBoxRedesign = styled(ProductSizeBoxRedesign)`
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`
